import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  alert: {
    '&.MuiAlert-standardWarning': {
      backgroundColor: '#fad9d161',
      borderRadius: '8px',
      border: 'solid 1px #FAD9D1',
      display: 'flex',
      alignItems: 'center',
      '& .MuiAlert-icon': {
        fontSize: '30px',
        color: '#E03E1A',
        display: 'none',
      },
      '& .MuiAlert-message': {
        display: 'flex',
        gap: '12px',
      },
    },
  },
  content: {
    '& h3': {},
    '& p': {
      fontSize: '13px',
    },
  },
  partTitle: {
    fontWeight: 'bold',
    color: theme.palette.primary.dark,
    fontSize: 14,
  },
  chip: {
    marginBottom: 8,
    marginInlineEnd: 5,
    backgroundColor: theme.palette.primary.lighter,
    '&:focus': {
      backgroundColor: theme.palette.primary.light,
    },
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
    },
  },
  btnChangeOwner: {
    '@media(min-width: 600px)': {
      marginTop: 31,
      width: 'auto',
    },
  },
  iconStyle: {
    border: '1px solid #ccc',
    borderRadius: '2px',
    padding: '2px',
    position: 'absolute',
    right: '24px',
    cursor: 'pointer',
  },
  agentRow: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
    },
  },
  inquiryBox: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  titles: {
    fontSize: '13px',
    color: '#455a64',
    '& span': {
      fontWeight: 'bold',
      color: '#ef5350',
      marginRight: '7px',
    }

  },
  btnChange: {
    margin: '32px',
    width: '100%',
    padding: '1px',
    [theme.breakpoints.down('sm')]: {
      margin: '0',
    },
    [theme.breakpoints.down('md')]: {

      width: '100% important',
    },
    [theme.breakpoints.up('sm')]: {
      width: '60%',
    },
    [theme.breakpoints.up('md')]: {
      width: '100%',
      fontSize: '12px'
    },
  },
  marginAllAgent: {
    margin: '0 8px',
  },
}));
